<bci-wk-modal class="modal">
  <div class="container-modal">
    <img
      class="war"
      src="./assets/images/icon-warning-dates.png"
      alt="waricon"
    />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title bciWkTypeH600
        >Día sin horas disponibles</bci-wk-modal-title
      >
    </div>
    <div class="subtitle">
      <p>
        Puedes seleccionar otro día o cambiar la sucursal en el paso anterior
        para que puedas concretar el motivo de tu visita.
      </p>
    </div>
    <bci-wk-modal-actions>
      <button bciWkButtonSecondary (click)="prevStep()">
        Cambiar sucursal
      </button>
      <button bciWkButtonPrimary (click)="close()">Seleccionar otro día</button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
